// Add an event listener to the checkbox
document.body.addEventListener("change", function (event) {

    const wrapper = document.querySelector('.cart-uspell-wrapper');
    if(!wrapper) return;

    function addGiftBoxToCart(variantId) {
        wrapper.querySelector(`[data-product-id="${variantId}"]`)?.click();
    }

    function removeGiftBoxToCart(variantId) {
        document.querySelector(`.cart-drawer .product-cart-items .product-cart-item-info [data-variant-id="${variantId}"]`)?.click();
    }
    
    // Get the checkbox element
    const checkbox = wrapper.querySelector("#cartDrawerGiftBox");
    const variantId = checkbox.dataset.variantId;

    if (event.target && event.target.id === "cartDrawerGiftBox") {
        const checkbox = event.target;
        if (checkbox.checked) {
        addGiftBoxToCart(variantId);
        } else {
        removeGiftBoxToCart(variantId);
        }
    }
});
  